import { useTranslation } from 'services/i18n'

import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'

import type { FC } from 'react'

type Props = {
  attachmentStatus: AttachmentWithUploadStatus['status']
}

export const AttachmentStatus: FC<Props> = ({ attachmentStatus }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'file_upload.upload_status',
  })

  if (attachmentStatus === 'deleting') return <div>{t('deleting')}</div>
  if (attachmentStatus === 'uploading') return <div>{t('uploading')}</div>

  return null
}
